import React, { useState, useEffect } from "react";
import api from "../services/api";

import {
DndContext,
closestCenter
} from "@dnd-kit/core";

import {
SortableContext,
verticalListSortingStrategy,
arrayMove,
useSortable
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";


/* ----------------------------------
   SORTABLE ROW COMPONENT
---------------------------------- */

function SortableRow({module,index,courses,startEdit,deleteModule}){

const {
attributes,
listeners,
setNodeRef,
transform,
transition
} = useSortable({id:module.id});

const style={
transform:CSS.Transform.toString(transform),
transition
};

const course=courses.find(c=>c.id===module.course_id);

return(

<tr ref={setNodeRef} style={{...style,...row}}>

<td
{...attributes}
{...listeners}
style={{cursor:"grab",fontSize:"18px",textAlign:"center"}}
>
☰
</td>

<td>{index+1}</td>

<td>{module.title}</td>

<td>{course ? course.title : ""}</td>

<td>

<button
style={editBtn}
onClick={()=>startEdit(module)}
>
Edit
</button>

<button
style={deleteBtn}
onClick={()=>deleteModule(module.id)}
>
Delete
</button>

</td>

</tr>

)

}



/* ----------------------------------
   MAIN MODULES COMPONENT
---------------------------------- */

function Modules(){

const [title,setTitle] = useState("");
const [courseId,setCourseId] = useState("");

const [courses,setCourses] = useState([]);
const [modules,setModules] = useState([]);

const [editingId,setEditingId] = useState(null);
const [filterCourse,setFilterCourse] = useState("");


useEffect(()=>{
loadCourses();
loadModules();
},[]);


const loadCourses = async ()=>{
const res = await api.get("/courses");
setCourses(res.data.data);
};


const loadModules = async ()=>{
const res = await api.get("/modules");
setModules(res.data.data);
};


const createModule = async ()=>{

if(!title || !courseId){
alert("Please fill all fields");
return;
}

await api.post("/modules",{
title,
course_id:courseId
});

setTitle("");
setCourseId("");

loadModules();

};


const startEdit = (module)=>{
setEditingId(module.id);
setTitle(module.title);
setCourseId(module.course_id);
};


const updateModule = async ()=>{

await api.put(`/modules/${editingId}`,{
title,
course_id:courseId
});

setEditingId(null);
setTitle("");
setCourseId("");

loadModules();

};


const deleteModule = async(id)=>{

const confirmDelete = window.confirm(
"Are you sure you want to delete this module?"
);

if(!confirmDelete) return;

await api.delete(`/modules/${id}`);

loadModules();

};


const filteredModules = filterCourse
? modules.filter(m=>m.course_id===filterCourse)
: modules;


/* ----------------------------------
   DRAG HANDLER
---------------------------------- */

const handleDragEnd = async (event)=>{

const {active,over} = event;

if(!over || active.id===over.id) return;

const oldIndex = modules.findIndex(m=>m.id===active.id);
const newIndex = modules.findIndex(m=>m.id===over.id);

const newModules = arrayMove(modules,oldIndex,newIndex);

setModules(newModules);

try{

await api.put("/modules/reorder",{
modules: newModules.map((m,index)=>({
id:m.id,
sort_order:index+1
}))
});

}catch(err){
console.log(err);
}

};



return(

<div style={{padding:"30px"}}>

<h2 style={{marginBottom:"25px"}}>Modules</h2>


{/* CREATE MODULE CARD */}

<div style={card}>

<h3 style={{marginBottom:"15px"}}>
{editingId ? "Edit Module" : "Create Module"}
</h3>

<div style={{display:"flex",flexDirection:"column",gap:"10px",maxWidth:"450px"}}>

<input
placeholder="Module Title"
style={input}
value={title}
onChange={(e)=>setTitle(e.target.value)}
/>

<select
style={input}
value={courseId}
onChange={(e)=>setCourseId(e.target.value)}
>

<option value="">Select Course</option>

{courses.map(c=>(
<option key={c.id} value={c.id}>
{c.title}
</option>
))}

</select>

{editingId ? (

<button style={successBtn} onClick={updateModule}>
Update Module
</button>

) : (

<button style={primaryBtn} onClick={createModule}>
Add Module
</button>

)}

</div>

</div>


{/* MODULE LIST CARD */}

<div style={card}>

<h3 style={{marginBottom:"20px"}}>Modules List</h3>

<select
style={{...input,maxWidth:"250px",marginBottom:"15px"}}
value={filterCourse}
onChange={(e)=>setFilterCourse(e.target.value)}
>

<option value="">All Courses</option>

{courses.map(c=>(
<option key={c.id} value={c.id}>
{c.title}
</option>
))}

</select>


<DndContext
collisionDetection={closestCenter}
onDragEnd={handleDragEnd}
>

<SortableContext
items={filteredModules.map(m=>m.id)}
strategy={verticalListSortingStrategy}
>

<table style={table}>

<thead style={tableHeader}>

<tr>
<th style={{width:"40px"}}></th>
<th>#</th>
<th>Module Name</th>
<th>Course</th>
<th>Actions</th>
</tr>

</thead>

<tbody>

{filteredModules.map((m,index)=>(

<SortableRow
key={m.id}
module={m}
index={index}
courses={courses}
startEdit={startEdit}
deleteModule={deleteModule}
/>

))}

</tbody>

</table>

</SortableContext>
</DndContext>

</div>

</div>

)

}



/* ---------- UI STYLES ---------- */

const card = {

background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
marginBottom:"30px"

};

const input = {

padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px",
fontSize:"14px"

};

const primaryBtn = {

background:"#34495e",
color:"#fff",
border:"none",
padding:"10px",
borderRadius:"6px",
cursor:"pointer",
width:"160px"

};

const successBtn = {

background:"#27ae60",
color:"#fff",
border:"none",
padding:"10px",
borderRadius:"6px",
cursor:"pointer",
width:"160px"

};

const editBtn = {

background:"#f39c12",
border:"none",
color:"#fff",
padding:"6px 12px",
marginRight:"8px",
borderRadius:"4px",
cursor:"pointer"

};

const deleteBtn = {

background:"#e74c3c",
border:"none",
color:"#fff",
padding:"6px 12px",
borderRadius:"4px",
cursor:"pointer"

};

const table = {

width:"100%",
borderCollapse:"collapse"

};

const tableHeader = {

background:"#f5f6fa",
textAlign:"left"

};

const row = {

borderBottom:"1px solid #eee"

};

export default Modules;